/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> (and
// <%= stylesheet_pack_tag 'hello_vue' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

// import Vue from 'vue'
// import App from '../app.vue'

// document.addEventListener('DOMContentLoaded', () => {
//   const app = new Vue({
//     render: h => h(App)
//   }).$mount()
//   document.body.appendChild(app.$el)

//   console.log(app)
// })

// The above code uses Vue without the compiler, which means you cannot
// use Vue to target elements in your existing html templates. You would
// need to always use single file components.
// To be able to target elements in your existing html/erb templates,
// comment out the above code and uncomment the below
// Add <%= javascript_pack_tag 'hello_vue' %> to your layout
// Then add this markup to your html template:
//
// <div id='hello'>
//   {{message}}
//   <app></app>
// </div>

import Vue from "vue/dist/vue.esm";
import Vuex from "vuex";
import QuickQuote from "../QuickQuote.vue";
import axios from "axios";

Vue.prototype.$axios = axios;
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isLoading: false,
    variantIds: {
      gradeAlloy: [],
      primaryDimension: [],
      specification: []
    }
  },
  mutations: {
    setLoading(state, val) {
      state.isLoading = val;
    },
    updateVariantIds(state, { filter, variantIds }) {
      if (Object.keys(state.variantIds).includes(filter)) {
        state.variantIds[filter] = variantIds;
      } else {
        console.error(`Unknown variantId filter: ${filter}`);
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    el: "#quick-quote",
    components: { QuickQuote },
    store: store
  });
});
